export default __webpack_public_path__ + "static/media/mastercard-selected.05ce10d0.svg";